import { __exports as i } from "../../../../../../../_virtual/index3.js";
import "./constants.js";
import { __exports as s } from "../../../../../../../_virtual/constants.js";
Object.defineProperty(i, "__esModule", { value: !0 });
i.sanitizeUrl = void 0;
var e = s;
function h(r) {
  return e.relativeFirstCharacters.indexOf(r[0]) > -1;
}
function u(r) {
  var c = r.replace(e.ctrlCharactersRegex, "");
  return c.replace(e.htmlEntitiesRegex, function(t, a) {
    return String.fromCharCode(a);
  });
}
function o(r) {
  try {
    return decodeURIComponent(r);
  } catch {
    return r;
  }
}
function m(r) {
  if (!r)
    return e.BLANK_URL;
  var c, t = o(r);
  do
    t = u(t).replace(e.htmlCtrlEntityRegex, "").replace(e.ctrlCharactersRegex, "").replace(e.whitespaceEscapeCharsRegex, "").trim(), t = o(t), c = t.match(e.ctrlCharactersRegex) || t.match(e.htmlEntitiesRegex) || t.match(e.htmlCtrlEntityRegex) || t.match(e.whitespaceEscapeCharsRegex);
  while (c && c.length > 0);
  var a = t;
  if (!a)
    return e.BLANK_URL;
  if (h(a))
    return a;
  var n = a.match(e.urlSchemeRegex);
  if (!n)
    return a;
  var l = n[0];
  return e.invalidProtocolRegex.test(l) ? e.BLANK_URL : a;
}
i.sanitizeUrl = m;
export {
  i as default
};
